import gql from 'graphql-tag';
import gqlFetcher from '../lib/gqlFetcher';

const extractValue = (data) => typeof data !== 'object' ? !!data : (
	Object.entries(data).some(([k, v]) => k !== '__typename' && extractValue(v))
);

const buildGqlQuery = (name, vars, field) => {
	const varsEntries = Object.entries(vars);
	const varsFragment = varsEntries.length === 0 ? '' : `(${varsEntries.map(([k, v]) => `$${k}: ${v}`).join(', ')})`;
	const query = gql`query ACCESS_CONTROL__${name}${varsFragment}{ ${field} }`;
	return (
		async (_, varsValues) => extractValue(await gqlFetcher(query, varsValues))
	);
}
export default buildGqlQuery;
